<div class="mb-5">
  <div class="row justify-content-center">
    <div class="col-12 mb-3">
      <h6 class="text-center">{{ 'bvs.calculator.person.addressDataTitle' | transloco }}</h6>
    </div>

    <div class="col-12 mb-3">
      <app-question-box
        [id]="'address-country'"
        (answerSelect)="setCountry($event.value)"
        [answers]="countryAnswerOptions"
        [selectedValue]="form.controls.country.value"
        [title]="'address.country'"></app-question-box>
    </div>
  </div>

  @if (form.controls.country.value !== null) {
    <div class="row justify-content-center">
      <div class="col-sm-3 mb-3 text-center">
        <label class="form-label" for="street">{{ 'address.street' | transloco }}</label>
        <input
          [formControl]="form.controls.street"
          class="form-control form-control-sm"
          data-cy="street"
          id="street"
          type="text">
      </div>

      <div class="col-sm-3 mb-3 text-center">
        <label class="form-label" for="houseNumber">{{ 'address.houseNumber' | transloco }}</label>
        <input
          [formControl]="form.controls.houseNumber"
          class="form-control form-control-sm"
          data-cy="houseNumber"
          id="houseNumber"
          type="text">
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-sm-3 mb-3 text-center">
        <label class="form-label" for="zip">{{ 'address.zip' | transloco }}</label>
        <input
          [formControl]="form.controls.zip"
          class="form-control form-control-sm"
          data-cy="zip"
          id="zip"
          type="text">
      </div>

      <div class="col-sm-3 mb-3 text-center">
        <label class="form-label" for="city">{{ 'address.city' | transloco }}</label>
        <input
          [formControl]="form.controls.city"
          class="form-control form-control-sm"
          data-cy="city"
          id="city"
          type="text">
      </div>
    </div>

    @if (form.controls.country.value === Country.Austria) {
      <div class="row justify-content-center">
        <div class="col-sm-3 mb-3 text-center">
          <label class="form-label" for="bundesland">{{ 'address.bundesland' | transloco }}</label>
          <select
            [formControl]="form.controls.bundesland"
            class="form-select form-select-sm text-center"
            data-cy="bundesland"
            id="bundesland">
            @for (option of bundeslandOptions; track option.value) {
              <option [ngValue]="option.value">{{ option.labelKey | transloco }}</option>
            }
          </select>
        </div>
      </div>
    }
  }
</div>
